"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransmissionMethods = exports.getTransmissionMethodForKey = void 0;
const internalHelpers_1 = require("../internalHelpers");
const shared_1 = require("../models/shared");
const getTransmissionMethodForKey = async (accessToken, key, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/transmissionMethods/${key}`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getTransmissionMethodForKey = getTransmissionMethodForKey;
const getTransmissionMethods = async (accessToken, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/transmissionMethods`, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getTransmissionMethods = getTransmissionMethods;
